export default function BulkUploadStats({
  bulkInfo = { total: 0, enriched: 0, pending: 0, lastUploadedAt: null },
  limit,
  setLimit,
  setPage,
}) {
  // calculate enrichment %
  // const percentEnriched = useMemo(() => {
  //   return bulkInfo.total
  //     ? Math.round((bulkInfo.enriched / bulkInfo.total) * 100)
  //     : 0;
  // }, [bulkInfo]);

  return (
    <div className="space-y-6 mb-10">
      {/* Stats grid */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {[
          { label: "Total Vehicles", value: bulkInfo.total },
          { label: "Enriched", value: bulkInfo.enriched },
          { label: "Pending", value: bulkInfo.pending },
        ].map(({ label, value }) => (
          <div
            key={label}
            className="flex flex-col bg-white shadow rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <span className="text-xs font-medium text-gray-500">{label}</span>
            <span className="mt-1 text-2xl font-semibold text-gray-900">
              {value ?? 0}
            </span>
          </div>
        ))}

        <div className="col-span-1 sm:col-span-2 lg:col-span-2 flex flex-col justify-between bg-white shadow rounded-lg p-4">
          <span className="text-xs font-medium text-gray-500">
            Enrichment Progress
          </span>
          <div className="mt-2">
            <div
              className="w-full h-2 bg-gray-200 rounded-full overflow-hidden"
              role="progressbar"
              aria-valuenow={percentEnriched}
              aria-valuemin={0}
              aria-valuemax={100}
            >
              <div
                className="h-full bg-blue-600"
                style={{ width: `${percentEnriched}%` }}
              />
            </div>
            <p className="mt-1 text-sm text-gray-700">
              {percentEnriched}% complete
            </p>
          </div>
        </div>
      </div> */}

      {/* Controls row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-baseline space-x-1">
          <span className="text-sm text-white">Last CSV import:</span>
          <span className="text-sm font-medium text-accent">
            {bulkInfo.lastUploadedAt
              ? new Date(bulkInfo.lastUploadedAt).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              : "Never"}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <label htmlFor="rowsPerPage" className="text-sm text-white">
            Rows per page:
          </label>
          <select
            id="rowsPerPage"
            value={limit}
            onChange={(e) => {
              setLimit(+e.target.value);
              setPage(1);
            }}
            className="border border-gray-300 rounded text-primary py-1 text-sm focus:ring focus:ring-blue-200"
          >
            {[10, 25, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
